import { API_URL } from "constants/api-url";

let isAPICalled = false;
class GlobalInstanceManager {
  static webcomponentProps: Record<string, any> = {
    instance_id: "",
    env: "",
    lang: "en",
    verified_user: null,
  };

  static API_HOST = "https://authentication.stage.satschel.com";

  static setWebComponentProps(newProps: Record<string, any>): void {
    this.webcomponentProps = { ...this.webcomponentProps, ...newProps };
  }

  static getWebComponentProps<T = any>(key: string): T | undefined {
    return this.webcomponentProps[key];
  }

  static onErrorEvent(event: any) {
    GlobalInstanceManager.webcomponentProps.on_error?.(event);
  }

  static async onSuccessEvent(event: any) {
    if (!isAPICalled) {
      isAPICalled = true;
      const resp = await fetch(
        GlobalInstanceManager.webcomponentProps.apiUrl + API_URL.TOKEN,
        {
          headers: {
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({ requestId: event.requestId }),
        }
      );

      const data = await resp.json();
      if (resp.status === 200) {
        GlobalInstanceManager.webcomponentProps.on_complete?.(data);
      } else {
        GlobalInstanceManager.webcomponentProps.on_error?.(event);
      }
    }
  }

  static onLoadedEvent(event: any) {
    GlobalInstanceManager.webcomponentProps.on_loaded?.(event);
  }
  static onStepChangeEvent(event: any) {
    GlobalInstanceManager.webcomponentProps.on_step_change?.(event);
  }
}

export default GlobalInstanceManager;
